import React, { useState } from 'react';
import { CLASS_GROUP_META, CLASS_GROUPS } from '@/state/classSession';

export function SoundBankTray({ tracks = [], onMute, unavailableTrackIds = new Set() }) {
  const [open, setOpen] = useState(false);
  if (!tracks.length) return null;
  return <section className="sound-bank" data-testid="sound-bank">
    <button className="sound-bank-toggle" aria-expanded={open} onClick={() => setOpen((value) => !value)}>
      Sound bank: {tracks.length} more sound{tracks.length === 1 ? '' : 's'} <span>{open ? '▾' : '▸'}</span>
    </button>
    {open && <div className="sound-bank-body">{CLASS_GROUPS.map((group) => {
      const groupTracks = tracks.filter((track) => track.classSlot?.group === group);
      if (!groupTracks.length) return null;
      return <div key={group} className="sound-bank-group" style={{ '--class-group-color': CLASS_GROUP_META[group].color }}>
        <h4>{CLASS_GROUP_META[group].label}</h4>
        {groupTracks.map((track) => <div key={track.id} className="sound-bank-row" data-testid={`bank-track-${track.id}`}>
          <span className="sound-bank-dot" /><span>{track.name}</span>
          {unavailableTrackIds.has(track.id) && <small>sound unavailable</small>}
          <button data-testid={`bank-mute-${track.id}`} aria-label={`Unmute ${track.name}`} aria-pressed={track.muted} onClick={() => onMute?.(track.id)}>M</button>
        </div>)}
      </div>;
    })}</div>}
  </section>;
}

export default SoundBankTray;
